import axios from "axios";
import { getToken } from "./auth";

const API = process.env.REACT_APP_BACKEND_URL
  ? `${process.env.REACT_APP_BACKEND_URL}/api/agent`
  : "/api/agent";

function authHeaders(token) {
  const t = token ?? getToken();
  return t ? { headers: { Authorization: `Bearer ${t}` } } : {};
}

export async function listContexts(token) {
  const res = await axios.get(`${API}/contexts`, authHeaders(token));
  return res.data;
}

export async function openConversation(token, contextName) {
  const res = await axios.get(
    `${API}/conversations/${contextName}`,
    authHeaders(token),
  );
  return res.data;
}

export async function sendMessage(token, contextName, message, urgent = false) {
  const res = await axios.post(
    `${API}/conversations/${contextName}/message`,
    { message, urgent },
    authHeaders(token),
  );
  return res.data;
}

export async function sendMessageWithImage(token, contextName, message, files, urgent = false) {
  const form = new FormData();
  form.append("message", message ?? "");
  const imageFiles = Array.isArray(files) ? files : [files];
  imageFiles.filter(Boolean).forEach((file) => form.append("image", file));
  form.append("urgent", urgent);
  const res = await axios.post(
    `${API}/conversations/${contextName}/message-with-image`,
    form,
    authHeaders(token),
  );
  return res.data;
}

// image_path = "agent_screenshots/{user_id}/{filename}"
// route servie  = "/api/agent/screenshots/{user_id}/{filename}"
export function screenshotUrl(imagePath) {
  if (!imagePath) return null;
  return `/api/agent/${imagePath.replace(/^agent_screenshots\//, "screenshots/")}`;
}

export async function getUnreadCount(token) {
  const res = await axios.get(`${API}/unread-count`, authHeaders(token));
  return res.data;
}

export async function getMyRequests(token, scope = "mine") {
  const res = await axios.get(`${API}/my-requests?scope=${scope}`, authHeaders(token));
  return res.data;
}

export async function getDeliveries(token) {
  const res = await axios.get(`${API}/deliveries`, authHeaders(token));
  return res.data;
}

export async function getQuestionsForMe(token) {
  const res = await axios.get(`${API}/questions-for-me`, authHeaders(token));
  return res.data;
}

export async function getRequestDetail(token, id) {
  // `id` vient maintenant aussi de `?demande=` dans l'URL : il n'est plus
  // seulement choisi dans une liste rendue par nous.
  const res = await axios.get(
    `${API}/my-requests/${encodeURIComponent(id)}`,
    authHeaders(token),
  );
  return res.data;
}

export async function setRequestPriority(token, id, priority) {
  const res = await axios.put(
    `${API}/my-requests/${id}/priority`,
    { priority },
    authHeaders(token),
  );
  return res.data;
}

export async function postRequestComment(token, id, text) {
  const res = await axios.post(
    `${API}/my-requests/${id}/comments`,
    { text },
    authHeaders(token),
  );
  return res.data;
}

export async function postRequestCommentWithImage(token, id, text, file) {
  const form = new FormData();
  form.append("text", text);
  form.append("image", file);
  const res = await axios.post(
    `${API}/my-requests/${id}/comments-with-image`,
    form,
    authHeaders(token),
  );
  return res.data;
}
